import extend from 'lodash/extend'

export function evalFn (fn) {
  const Fn = Function
  return new Fn('return ' + fn)()
}

/**
 * 将配置文件转为可识别css像素
 * @param {*} config 
 * @returns 
 */
export function transfCssUtil (conf = {}) {
  if (Array.isArray(conf)) {
    conf = arrToPx(conf)
  }
  // return recursionCss(conf)
  const temp = recursionCss(conf)
  return JSON.parse(pxToRem(JSON.stringify(temp)))
}

function recursionCss (conf) {
  let temp = {}
  for (let prop in conf) {
    if (isObj(conf[prop])) {
      temp[prop] = recursionCss(conf[prop])
    } else if (Array.isArray(conf[prop])) {
      temp[prop] = arrToPx(conf[prop])
    } else {
      temp[prop] = conf[prop]
    }
  }
  return temp
}

// 数组转可识别像素
export function arrToPx (arr) {
  return arr.map(item => item !== 'auto' ? `${item}px` : item).join(' ')
}

// pxToRem
export function pxToRem (str, options) {
  const pxRegex = /(\d*\.?\d+)px/ig

  options = extend({
    rootValue: 16,
    unitPrecision: 5,
    minPixelValue: 0
  }, options)

  function createPxReplace(rootValue, unitPrecision, minPixelValue) {
    return function (m, $1) {
      if (m.indexOf('px') === -1) {
        return m
      }
      if (!$1) {
        return m
      }
      let pixels = parseFloat($1)

      if (pixels < minPixelValue) {
        return m
      }
      return toFixed((pixels / rootValue), unitPrecision) + 'rem'
    }
  }

  function toFixed(number, precision) {
    let multiplier = Math.pow(10, precision + 1)
    let wholeNumber = Math.floor(number * multiplier)
    return Math.round(wholeNumber / 10) * 10 / multiplier
  }

  let pxReplace = createPxReplace(options.rootValue, options.unitPrecision, options.minPixelValue)

  return str.replace(pxRegex, pxReplace)
}

function isObj (obj) {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    return true
  } else {
    return false
  }
}

/** 处理额外的样式细节点 */
export function execStyle (confClone, dataObject, key) {
  const config = confClone.__config__
  if (config.tag === 'el-image' && confClone.__slot__.link) {
    dataObject[key]['cursor'] = 'pointer'
  }
  if (config.tagIcon === 'container') {
    if (confClone.style.background) {
      dataObject['style']['background'] = `url(${confClone.style.background}) center center / cover no-repeat`
    } else {
      dataObject['style']['background-color'] = confClone.style.backgroundColor
    }
  }
}

function genAOSAnimationAttrs (config) {
  return {
    'data-aos': config.name,
    'data-aos-duration': config.duration,
    'data-aos-delay': config.delay,
    'data-aos-easing': config.easing,
  }
}
function genWOWAnimationAttrs (config) {
  return {
    // 'data-wow-iteration': 2,
  }
}

export function genAnimationAttrs (options = {}, dataObject) {
  const { lib, enabled, config } = options 
  if (!enabled || !lib || !config) {
    return 
  }
  let animationAttrs = {}
  if (lib === 'aos') {
    animationAttrs = genAOSAnimationAttrs(config)
  } else if (lib === 'wow') { 
    animationAttrs = genWOWAnimationAttrs(config)
    dataObject.class['wow'] = true
    dataObject.class[`animate__${config.name}`] = true
  }
  Object.keys(animationAttrs).forEach(key => {
    dataObject.attrs[key] = animationAttrs[key]
  })
}